import React, { useState, useEffect } from 'react';

const Stopwatch = () => {
  const [time, setTime] = useState(0);
  const [isRunning, setIsRunning] = useState(false);
  const [buttonText, setButtonText] = useState('Start');
  const [laps, setLaps] = useState([]);
  const [lowestDiff, setLowestDiff] = useState(null);
  const [highestDiff, setHighestDiff] = useState(null);

  useEffect(() => {
    let intervalId = null;

    if (isRunning) {
      intervalId = setInterval(() => {
        setTime((prevTime) => prevTime + 10);
      }, 10);
    } else {
      clearInterval(intervalId);
    }

    return () => {
      clearInterval(intervalId);
    };
  }, [isRunning]);

  const toggleStopwatch = () => {
    if (isRunning) {
      setIsRunning(false);
      setButtonText('Resume');
    } else {
      setIsRunning(true);
      setButtonText('Pause');
    }
  };

  const stopStopwatch = () => {
    setTime(0);
    setIsRunning(false);
    setButtonText('Start');
    setLaps([]);
    setHighestDiff(null);
    setLowestDiff(null);
  };

  const resetStopwatch = () => {
    setTime(0);
    setIsRunning(false);
    setButtonText('Start');
    setLaps([]);
    setHighestDiff(null);
    setLowestDiff(null);
  };

  const recordLap = async() => {
    console.log('Inside recordLap');
    const elapsed = time;
    const diff = calculateDiff();
    await updateDiffStats(diff)
    setLaps((prevLaps) => [...prevLaps, { elapsed, diff }]);
  };


  useEffect(() => {
    console.log('laps.length: ', laps.length);
    if (laps.length>0) {
      console.log('lowestDiff: ', lowestDiff);
      if (lowestDiff !== null) {
        const low = timeToMilliseconds(lowestDiff);
        const current = timeToMilliseconds(laps[laps.length - 1]?.diff);
        if (current < low && current !== 0) {
          setLowestDiff(laps[laps.length - 1]?.diff);
        }
      }
  
      console.log('highestDiff: ', highestDiff);
      if (highestDiff !== null) {
        const high = timeToMilliseconds(highestDiff);
        const current = timeToMilliseconds(laps[laps.length - 1]?.diff);
        if (current > high) {
          setHighestDiff(laps[laps.length - 1]?.diff);
        }
      }
    }
  }, [laps, lowestDiff, highestDiff]);

  const calculateDiff = () => {
    console.log('Inside calculateDiff');
    if (laps.length > 0) {
      const prevLap = laps[laps.length - 1];
      return formatTime(time - prevLap.elapsed);
    } else {
      return '00:00:00:000';
    }
  };

  const formatTime = (time) => {
    const hours = Math.floor(time / (60 * 60 * 1000));
    const minutes = Math.floor((time % (60 * 60 * 1000)) / (60 * 1000));
    const seconds = Math.floor((time % (60 * 1000)) / 1000);
    const milliseconds = Math.floor(time % 1000);
    const ans = `${padWithZero(hours)}:${padWithZero(minutes)}:${padWithZero(seconds)}:${padMilliseconds(milliseconds)}`
    // console.log('Inside formatTime: returning time: ',ans);
    return ans;
  };

  const padWithZero = (value) => {
    return value.toString().padStart(2, '0');
  };

  const padMilliseconds = (value) => {
    return value.toString().padStart(3, '0');
  };

  const updateDiffStats = async(diff) => {
    // console.log('Inside updateDiffStats');
    // console.log('diff: ', diff);
    // console.log('lowestDiff: ', lowestDiff);
    // console.log('highestDiff: ', highestDiff);

    const current = timeToMilliseconds(diff);
    // console.log('current: ', current);

    if (lowestDiff === null && diff !== '00:00:00:000'){
      // console.log("Setting lowest diff", diff);
      await setLowestDiff(diff);
    }
    if (lowestDiff !== null) {
      const low = timeToMilliseconds(lowestDiff);
      // console.log('low: ', low);
      if ((low!==0)&&(current<low)) {
        // console.log("Setting lowest diff", diff);
        await setLowestDiff(diff);
      }
    }

    if (highestDiff === null){
      // console.log("Setting Highest diff", diff);
      await setHighestDiff(diff);
    }
    else if (highestDiff !== null) {
      const high = timeToMilliseconds(highestDiff);
      // console.log('high: ', high);
      if (current>high){
        // console.log("Setting Highest diff", diff);
        await setHighestDiff(diff);
      }
    }
  };

function timeToMilliseconds(time) {
  const [hours, minutes, seconds, milliseconds] = time.split(':');
  const totalMilliseconds =
  (parseInt(hours) * 60 * 60 * 1000) +
  (parseInt(minutes) * 60 * 1000) +
  (parseInt(seconds) * 1000) +
  parseInt(milliseconds);
  
  // console.log('Inside timeToMilliseconds', '| time:', time, '| totalMilliseconds:', totalMilliseconds );
  return totalMilliseconds;
}
  return (
    
    // console.log("highestDiff: ",highestDiff,"| lowestDiff: ",lowestDiff,"\n laps: ",laps),
    <div className='border'>
      <h1>{formatTime(time)}</h1>
      <div>
        <div>
          <button className='border' style={{ margin: '10px' }} onClick={toggleStopwatch}>
            {buttonText}
          </button>
          {isRunning && (
            <button className='border' onClick={stopStopwatch} disabled={!isRunning}>
              Stop
            </button>
          )}
          {!isRunning && (
            <button className='border' onClick={resetStopwatch} disabled={isRunning}>
              Reset
            </button>
          )}
        </div>
        <button className='border' style={{ width: '200px' }} onClick={recordLap}>
          Lap
        </button>
      </div>
      {laps.length > 0 && (
        <div className='border' style={{ height: '139px', width:'250px', padding:'5px', overflowY: 'scroll' }}>
          Elapsed Time | Difference
          {laps.slice().reverse().map((lap, index) => (
            <li
              key={index}
              style={{
                color:
                  lap.diff === lowestDiff
                    ? 'green'
                    : lap.diff === highestDiff
                      ? 'red'
                      : 'black',
              }}
            >
              {formatTime(lap.elapsed)} | {lap.diff}
            </li>
          ))}
        </div>
      )}
    </div>
  );
};

export default Stopwatch;
